import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import useEncripterLocalStorage from "../../../hooks/useEncripter";
import { formatearMensajeBackend } from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";

import { getCurrentDomain } from "../../../apis/backend/Api";

const { Cookies: Cookies_ } = require("react-cookie");
const cook = new Cookies_();
interface State {
  oauth: any[];
  session: any[];
  cuenta: any[];
  readMails: any[];
  seeProfile: any[];
  TokenApi: string;
  IdSesion: string;
  IdPerfil: string;
  IdCliente: string;
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  oauth: [],
  session: [],
  cuenta: [],
  readMails: [],
  seeProfile: [],
  TokenApi: "",
  IdSesion: "",
  IdPerfil: "",
  IdCliente: "",
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
};

interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const oauthSlice = createSlice({
  name: "oauth",
  initialState,
  reducers: {
    setOauth: (state, action: PayloadAction<any[]>) => {
      state.oauth = action.payload;
    },
    setCuenta: (state, action: PayloadAction<any[]>) => {
      state.cuenta = action.payload;
    },
    setSession: (state, action: PayloadAction<any[]>) => {
      state.session = action.payload;
    },
    setSeeProfile: (state, action: PayloadAction<any[]>) => {
      state.seeProfile = action.payload;
    },
    setReadMails: (state, action: PayloadAction<any[]>) => {
      state.readMails = action.payload;
    },

    setIdSesion: (state, action: PayloadAction<string>) => {
      state.IdSesion = action.payload;
    },
    setTokenApi: (state, action: PayloadAction<string>) => {
      state.TokenApi = action.payload;
    },
    setIdPerfil: (state, action: PayloadAction<string>) => {
      state.IdPerfil = action.payload;
    },
    setIdCliente: (state, action: PayloadAction<string>) => {
      state.IdCliente = action.payload;
    },
    getoauth: (state, action: PayloadAction<any[]>) => {
      state.oauth = action.payload;
    },
    setClearOauth: (state, action: PayloadAction<any[]>) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
  },
});
//

// Función para agregar datos a sessionStorage
interface SessionData {
  [id: string]: { email: string; telefono: string }[];
}

// Función para agregar datos a sessionStorage
function agregarDatosASession(
  idSession: string,
  email: string,
  telefono: string,
): void {
  // Obtener los datos de sessionStorage
  const sessionData: SessionData = JSON.parse(
    sessionStorage.getItem("session") || "{}",
  );

  // Verificar si ya existe un array de datos para el idSession dado
  if (!sessionData[idSession]) {
    sessionData[idSession] = [];
  }

  // Agregar los datos al array del idSession
  sessionData[idSession].push({ email, telefono });

  // Guardar los datos actualizados en sessionStorage
  sessionStorage.setItem("session", JSON.stringify(sessionData));
}
// Función para obtener datos de sessionStorage por idSession
function obtenerDatosPorId(
  idSession: string,
): { email: string; telefono: string }[] | undefined {
  // Obtener los datos de sessionStorage
  const sessionData: SessionData = JSON.parse(
    sessionStorage.getItem("session") || "{}",
  );

  // Verificar si existe un array de datos para el idSession dado
  if (sessionData[idSession]) {
    return sessionData[idSession];
  }

  return undefined;
}

export const setOauthAzure =
  (response: Promise<void>): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    let usuariosCliente: any[] = [];

    dispatch(setIsLoading(true));
    try {
      let response: AxiosResponse = defaultResp;

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
      } else {
        const headers = response.headers;
        sessionStorage.setItem("headers", JSON.stringify(headers));
        if (headers && headers["set-cookie"]) {
          const cookies = headers["set-cookie"];
          sessionStorage.setItem("cookies", JSON.stringify(cookies));
        }
        dispatch(
          setIdPerfil(String(response.data.Data[0].usuario.perfil.IdPerfil)),
        );
        dispatch(setOauth(response.data.Data));
        dispatch(setIsLoading(false));
        dispatch(setSuccess(true));

        if (response.data.Data[0].usuario.perfil.IdPerfil === 3) {
          for (
            let i = 0;
            i < response.data.Data[0].usuario.ClientesAdministrados.length;
            i++
          ) {
            const cliente =
              response.data.Data[0].usuario.ClientesAdministrados[i];
            usuariosCliente.push(cliente.UsuariosBonita);
          }
          dispatch(setSession(usuariosCliente));
        }

        if (response.data.Data[0].usuario.perfil.IdPerfil === 3) {
          dispatch(
            setSession(response.data.Data[0].usuario.ClientesAdministrados),
          );
        }
        dispatch(setStatus("succeeded"));
        dispatch(setOauth(response.data.Data));
        sessionStorage.setItem("setOauth", JSON.stringify(response.data.Data));
        dispatch(
          setIdPerfil(String(response.data.Data[0].usuario.perfil.IdPerfil)),
        );
        dispatch(
          setIdCliente(String(response.data.Data[0].usuario.cliente.IdCliente)),
        );
        dispatch(setIdSesion(String(response.data.Data[0].IdSesion)));
        dispatch(setTokenApi(String(response.data.Data[0].TokenApi)));
        sessionStorage.setItem(
          "TokenApi",
          JSON.stringify(response.data.Data[0].TokenApi),
        );
        await cook.set("IdSesion", response.data.Data[0].IdSesion);
        await cook.set("TokenApi", response.data.Data[0].TokenApi);
        await sessionStorage.setItem(
          "IdSesion",
          response.data.Data[0].IdSesion,
        );
        await sessionStorage.setItem(
          "TokenApi",
          response.data.Data[0].TokenApi,
        );
        await sessionStorage.setItem(
          "usuario",
          JSON.stringify(response.data.Data[0].usuario),
        );
      }
      dispatch(setMensaje(formatearMensajeBackend(response.data?.Mensaje)));

      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };
//
export const setOauthAzureLogOut =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      let response: AxiosResponse = defaultResp;
      dispatch(setClearOauth([]));
      dispatch(setIsLoading(false));
      dispatch(setStatus("idle"));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const {
  setOauth,
  setSession,
  setCuenta,
  setSeeProfile,
  setReadMails,
  setTokenApi,
  setIdSesion,
  setIdPerfil,
  setIdCliente,
  setClearOauth,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
} = oauthSlice.actions;

export default oauthSlice.reducer;
